import React from 'react';
import * as PropTypes from 'prop-types';
import SecurityGroupDetails from './create/SecurityGroupDetails';
import Permissions from './create/permissions/Permissions';
import ErrorMessage from '../common/ErrorMessage';
import UsersTableContainer from './create/users/UsersTableContainer';
import SecurityGroupModal from './create/users/SecurityGroupModal';
import ConfirmModal from '../common/ConfirmModal';
import { RoleTypes } from '../../constants/Enums';


const SecurityGroupForm = props => {
    let isDisabled = props.roleType != null;
    return (
        <div className="container mt-4">
            <ErrorMessage isVisible={props.showError} message={props.errorMessage} />
            <SecurityGroupDetails handleSubmit={props.handleSubmit} buttonIsDisabled={props.buttonIsDisabled}
                                  cancel={props.cancel} mode={props.mode} disabled={isDisabled} />
            <Permissions
                apps={props.apps}
                permissions={props.permissions}
                addApp={props.addApp}
                removeApp={props.removeApp}
            />

            <UsersTableContainer toggleSecurityModal={props.toggleSecurityModal} />
            {props.isModalOpen && <SecurityGroupModal />}

            <ConfirmModal
                heading={'Warning!'}
                content={'No offices found. Please select at least one office when using '
                    + 'the \'Selected Offices\' scope option.'}
                isOpen={props.showNoRosterOfficesModal}
                confirm={() => props.setNoRosterOfficesModalOpen(false)}
                cancelButtonText={null}
                confirmButtonText={'Continue'}
            />

            <ConfirmModal
                heading={'Add Users?'}
                content={
                    'Any selected users that are currently in a security group will be removed ' +
                    'and assigned to this group. Are you sure you want to continue?'
                }
                isOpen={props.showConfirmModal} cancel={() => props.setBothModalOpen(false)}
                confirm={!props.showConflictModal
                    ? props.submitForm
                    : () => props.setConfirmModalOpen(false)
                }
                cancelButtonText={'Cancel'}
                confirmButtonText={'Continue'}
            />
            {props.securityGroup !== undefined && props.securityGroup !== null
                ? <ConfirmModal
                    heading={'Warning!'}
                    content={
                        'Warning! You are about to turn off the Manage Roles permission for your security group ("' +
                        props.securityGroup.name +
                        '"). If you choose to do this, you will no longer have access to Permissions from Home UI. ' +
                        'Are you sure you want to proceed?'
                    }
                    isOpen={props.showConflictModal && !props.showConfirmModal}
                    cancel={() => props.setBothModalOpen(false)}
                    confirm={props.submitForm}
                    cancelButtonText={'No, I would like to keep my access.'}
                    confirmButtonText={'Yes, remove my access.'} />
                : null
            }
            <ConfirmModal
                heading={'Warning!'}
                content={
                    'This permission must remain on for at least one role. ' +
                    'If you\'d like to turn it off for this role, you must first turn it on for another role.'
                }
                isOpen={props.showLastRemainingModal}
                confirm={() => props.setLastRemainingModalOpen(false)}
                cancelButtonText={null}
                confirmButtonText={'Okay'}
                cancel={null}
            />
        </div>
    )
};

SecurityGroupForm.propTypes = {
    isFetching: PropTypes.bool,
    showError: PropTypes.bool,
    errorMessage: PropTypes.string,
    apps: PropTypes.array,
    mode: PropTypes.number,
    handleSubmit: PropTypes.func,
    toggleSecurityModal: PropTypes.func,
    cancel: PropTypes.func.isRequired,
    showConfirmModal: PropTypes.bool,
    showConflictModal: PropTypes.bool,
    showNoRosterOfficesModal: PropTypes.bool,
    onlyOneLeftModal: PropTypes.bool,
    setConfirmModalOpen: PropTypes.func,
    setConflictModalOpen: PropTypes.func,
    setOnlyOneLeftModalOpen: PropTypes.func,
    setBothModalOpen: PropTypes.func,
    setNoRosterOfficesModalOpen: PropTypes.func,
    securityGroup: PropTypes.object,
    showLastRemainingModal: PropTypes.func,
    setLastRemainingModalOpen: PropTypes.func,
    submitForm: PropTypes.func,
    buttonIsDisabled: PropTypes.func,
    permissions: PropTypes.array,
    isModalOpen: PropTypes.bool,
    roleType: PropTypes.number,
    addApp: PropTypes.func.isRequired,
    removeApp: PropTypes.func.isRequired
};

export default SecurityGroupForm;
